<template>
	<div id="shanglei">
		<div class="fflex ffbet">
			<ul class="fflex headBox">
				<li class="active">商品类型</li>
				<li @click="jump('gongys')">供应商</li>
				<li @click="jump('shangx')">商品信息</li>
				<li @click="jump('wuliu')">物流设置</li>
				<li @click="jump('churukl')">出入库类型</li>
				<li @click="jump('rizhi')">日志列表</li>
			</ul>
			<div class="sousuok">
				<el-input size="mini" type="search" placeholder="商品类型查询" v-model="leixingsearch" @keypress="searchname" @keyup.enter.native="searchname" style="border: 1px solid gainsboro;">
					<i class="el-icon-search el-input__icon" slot="suffix" v-on:click="searchname">
					</i>
				</el-input>
			</div>
		</div>

		<div class="fflex ffend" style="margin-top: 5px;margin-bottom: 10px">
			<div class="sousuok" style="margin-right: 10px">
				<el-input size="mini" placeholder="输入类名称添加" v-model="tjleix" @keyup.enter.native="tianjia" style="border: 1px solid gainsboro;"></el-input>
			</div>
			<el-button type="success" round size="mini" class="purBtnsz" @click="tianjia">添加类型</el-button>
		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>类型编号</th>
						<th>类型名称</th>
						<th>创建时间</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>
							{{ta.type_num}}
						</td>
						<td>
							<span v-if="tableindex!=taindex+1">{{ta.type_name}}</span>
							<input type="text" v-model="ta.type_name" class="inp" v-if="tableindex==taindex+1">
							<span class="fl bcxg" v-if="tableindex==taindex+1" @click="baocun(ta.id,ta.type_name)">保存 </span>
						</td>
						<td>
							{{ta.create_time}}
						</td>

						<td>
							<span class="tablebtnBox">
								<div class="qianziBtn-mini" @click="xiubtn(taindex)">修改</div>
								<div class="shenziBtn-mini" @click="shanchu(ta.id)">删除</div>
							</span>
						</td>

					</tr>

				</tbody>
			</table>

		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				leixingsearch: '',
				tjleix: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				tabledata: '',
				//这个数据需要重置
				tableindex: 0,

			};
		},
		methods: {
			tianjia: function() {
				let self = this;
				if (!self.tjleix) {
					self.$message({
						type: 'error',
						message: '类型不能为空'
					});
					return;
				} else {
					self.$confirm('确认要添加此信息吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {

						$.ajax({
							type: 'POST',
							url: process.env.apiUrl + 'saas/JxcGoodsType/store',
							dataType: 'json',
							data: {
								type_name: self.tjleix,
								token: self.token
							},
							success: function(data) {

								if (data.status == 1) {
									self.$message({
										type: 'success',
										message: data.msg
									});
									self.tjleix = '';
									self.gonggong()

								} else {
									self.$message({
										type: 'error',
										message: data.msg
									});
								}

							}
						})

					}).catch(() => {


					});

				}

			},
			xiubtn: function(taindex) {
				if (this.tableindex == taindex + 1) {
					this.tableindex = 0
				} else {
					this.tableindex = taindex + 1
				}

			},
			shanchu: function(id) {

				let self = this;
				self.$confirm('确认要删除此信息吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcGoodsType/delete',
						dataType: 'json',
						data: {
							id: id,
							token: self.token
						},
						success: function(data) {

							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: '删除成功!'
								});

								self.gonggong()

							} else {
								self.$message({
									type: 'error',
									message: '删除失败!'
								});
							}

						}
					})

				}).catch(() => {});
			},
			baocun: function(id, type_name) {
				let self = this;
				self.$confirm('确认要修改吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcGoodsType/update',
						dataType: 'json',
						data: {
							id: id,
							type_name: type_name,
							token: self.token
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: '修改成功!'
								});
								self.gonggong()
							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});
							}

						}
					})

				}).catch(() => {
					self.gonggong()

				});

			},
			handleCurrentChange: function(i) {
				let self = this
				self.currentpage = Number(i)
				self.gonggong()
			},
			searchname: function() {
				let self = this;
				self.currentpage = 1
				self.gonggong()
			},
			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			gonggong: function() {
				let self = this;
				self.tableindex = 0
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcGoodsType/index',
					dataType: 'json',
					data: {
						page: self.currentpage,
						pageone: self.pageone,
						token: self.token,
						search: self.leixingsearch
					},
					success: function(data) {
						if (data.status == 1) {
							self.tabledata = data.data;
							self.total = Number(data.map.count)
						} else {
							self.tabledata = '';
							self.total = 0
						}


					}
				})

			}

		},
		mounted: function() {
			var self = this;
			self.token = $.cookie('token');

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + 'saas/JxcGoodsType/index',
				dataType: 'json',
				data: {
					page: 1,
					pageone: self.pageone,
					token: self.token
				},
				success: function(data) {
					if (data.status == 1) {
						self.tabledata = data.data;
						self.total = Number(data.map.count)
					} else {
						self.tabledata = '';
						self.total = 0
					}

				}
			})


		}


	}
</script>

<style scoped>
	ul {
		list-style: none;
	}

	#shanglei p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#shanglei * {
		box-sizing: border-box;
	}

	.bcxg {
		display: inline-block;
		width: 40px;
		height: 20px;
		line-height: 20px;
		margin-left: 5px;
		margin-top: 2px;
		background: #8CBB77;
		color: #FFFFFF;
		border-radius: 15px;
		cursor: pointer;
		font-size: 12px;
	}

	.inp {
		height: 24px;
		padding: 0;
		text-align: center;
		padding-left: 5px;
		padding-right: 5px;
		max-width: 100px;
		border: 1px solid #999999;
		position: relative;
		border-radius: 15px;
	}

	#shanglei {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/shanglei.vue